export default __webpack_public_path__ + "static/media/Mobile_Bio_Img@2x.3fbcfb32.png";